import { TdsDateInput, TdsField, TdsToggletip } from '@trv-tds/react'
import type { WrappedFieldInputProps } from 'redux-form'

const ClaimNumberHelpText = (
  <div>
    <h4 style={{ display: 'flex', justifyContent: 'center' }}>
      Where can I find my claim number?
    </h4>
    <hr />
    <p>
      Your claim number can be found in the documentation sent by Travelers. It is 7
      characters consisting of letters and numbers.
    </p>
    Examples:
    <ul>
      <li>ABC1234</li>
      <li>123-CB-<mark>ABC1234</mark>-T </li>
    </ul>
  </div>
)

const ClaimInput = ({ input, disabled }: { input: WrappedFieldInputProps; disabled: boolean }) => (
  <TdsField
    label='Claim Number'
    style={{ width: '50%' }}
    onFocus={input.onFocus}
    onBlur={input.onBlur}
  >
    <span slot="sublabel">
      <TdsToggletip toggle-label='Explain Claim Number' toggleIcon='question' toggleSize='medium'>
        {ClaimNumberHelpText}
      </TdsToggletip>
    </span>
    <input
      {...input}
      disabled={disabled}
      style={{ textTransform: 'uppercase' }}
      maxLength={7}
      name='Claim Number'
    />
  </TdsField>
)

const DateOfLossPicker = ({
  input,
  disabled
}: { input: WrappedFieldInputProps; disabled: boolean }) => (
  <TdsField label='Incident Date'>
    <span slot='hint' data-date-format-label>(MM/DD/YYYY)</span>
    <TdsDateInput
      name='dateOfLoss'
      value={input.value}
      disabled={disabled}
      onTdsFocus={(event: any) => input.onFocus(event)}
      onTdsBlur={(event: any) => input.onBlur(event)}
      onTdsChange={({ target }) => {
        // to prevent UX issues, only trigger change when it is a valid YYYY-MM-DD format
        if (!/^\d{4}-\d{2}-\d{2}$/.test(target.value)) return
        input.onChange(target.value)
      }}
    />
  </TdsField>
)

const RoleSelect = (
  isAuto: boolean,
  { input, disabled }: { input: WrappedFieldInputProps; disabled: boolean }
): JSX.Element => (
  <TdsField label='Role' style={{ width: '50%' }}>
    <span slot='sublabel'>
      <TdsToggletip
        toggle-label='Role'
        toggleIcon='info'
        toggleSize='medium'
      >
        Please fill out valid claim details before selecting your role.
      </TdsToggletip>
    </span>
    <select name='Role' onChange={input.onChange} value={input.value} disabled={disabled}>
      <option value="">Select Option</option>
      <option value="travelersPolicyHolder">Travelers Policyholder</option>
      <option value="claimant">Claimant</option>
      <option value="employee">Employee</option>
      <option value="medicalHealth">Medical Provider</option>
      <option value="repairCont">
        {isAuto ? 'Auto Repair Facility' : 'Repairer or Contractor'}
      </option>
      <option value="independentAdjuster">Independent Adjuster</option>
      <option value="hiredExpert">Hired Expert</option>
      <option value="legalRep">Legal Representative</option>
      <option value="agentBroker">Agent or Broker</option>
      <option value="otherCarrier">Insurance Company</option>
      <option value="cssCustomer">Constitution State Services Customer</option>
      <option value="other">Other</option>
    </select>
  </TdsField>
)

export {
  ClaimInput,
  DateOfLossPicker,
  RoleSelect
}
